import { push, uniqueId } from '../_core';
import { ERRORS_STACK_SIZE } from '../atoms';
export const pushError = ({ key, error, taskId }) => push({ key, error, id: uniqueId(), taskId }, ERRORS_STACK_SIZE);
//# sourceMappingURL=errors.js.map